exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-collection-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(83vh - 105px);\n}\n.create-collection-form__body {\n  margin: 8px 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Collections/components/CreateCollectionForm/createCollectionForm.less
// module id = 1222
// module chunks = 0